/* import __COLOCATED_TEMPLATE__ from './infinite-list.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { debounce } from '@ember/runloop';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { guidFor } from '@ember/object/internals';
const SCROLL_DEBOUNCE_INTERVAL_MS = 300;
const BOTTOM_OFFSET = 100;
/**
 * An infinite-scrolling list component where rows are rendered by the consumer.
 *
 * @class InfiniteList
 * @extends {Component}
 * @param {String} [containerSelector] The selector of the containing element; this must
 * be scrollable. If it is not provided, it will bind to the window/document scrollable container
 * @param {Object} [items] Optional list of items to yield within a block.
 * @param {number} [offset=100] Bottom offset from the terminus to call lastItemBecameVisible.
 * @param {Function} lastItemBecameVisible Called when the last item becomes visible; this should
 * be used by consumers to load more rows.
 */
let InfiniteList = (_dec = computed(), (_class = class InfiniteList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "offset", BOTTOM_OFFSET);
    // -- Component arguments -- //
    _defineProperty(this, "containerSelector", '');
    _defineProperty(this, "lastItemBecameVisible", () => {
      // No-op default.
    });
  }
  get terminusUniqueIdentifier() {
    return `${guidFor(this)}-infinite-list--terminus`;
  }
  didInsertElement() {
    super.didInsertElement();
    if (this.containerSelector) {
      const element = document.querySelector(this.containerSelector);
      element?.addEventListener('scroll', this._onScrollDebounced);
    } else {
      window.addEventListener('scroll', this._onScrollDebounced);
      document.addEventListener('touchmove', this._onScrollDebounced);
    }
  }
  willDestroyElement() {
    super.willDestroyElement();
    if (this.containerSelector) {
      const element = document.querySelector(this.containerSelector);
      element?.removeEventListener('scroll', this._onScrollDebounced);
    } else {
      window.removeEventListener('scroll', this._onScrollDebounced);
      document.removeEventListener('touchmove', this._onScrollDebounced);
    }
  }
  _onScrollDebounced() {
    debounce(this, this._onScroll, SCROLL_DEBOUNCE_INTERVAL_MS);
  }
  _onScroll() {
    if (this._isTheEnd()) {
      this.lastItemBecameVisible();
    }
  }
  _getRect() {
    const terminus = document.querySelector(`.${this.terminusUniqueIdentifier}`);
    return terminus.getBoundingClientRect();
  }
  _isTheEnd() {
    if (this.isDestroyed || this.isDestroying) {
      return null;
    }
    const boundingRectangle = this._getRect();
    const terminusTopWithOffset = boundingRectangle.top - this.offset;
    if (this.containerSelector) {
      const elementBoundingRectangle = document.querySelector(this.containerSelector)?.getBoundingClientRect();
      return elementBoundingRectangle ? terminusTopWithOffset <= elementBoundingRectangle.top + elementBoundingRectangle.height : false;
    } else {
      // if the top of the terminus is above the bottom of the screen
      return terminusTopWithOffset <= (window.innerHeight || document.documentElement.clientHeight);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "terminusUniqueIdentifier", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "terminusUniqueIdentifier"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_onScrollDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_onScrollDebounced"), _class.prototype)), _class));
export { InfiniteList as default };